module.exports = __webpack_public_path__ + "images/seat336d015b755bd0562e93670398610cf2.png";